"use client";

import type { PublicCommunityCountry } from "@/lib/community/types";
import { LocationFilterOption } from "./location-filter-option";

export type CountryCode = PublicCommunityCountry["code"];

const MAIN_COUNTRY_CODES: CountryCode[] = ["US", "GB", "CA", "AU", "DE", "FR"];

interface CountryFilterChipsProps {
  selected: CountryCode | null;
  onChange: (code: CountryCode | null) => void;
  countries: PublicCommunityCountry[];
  layout?: "grid" | "list";
}

export function CountryFilterChips({
  selected,
  onChange,
  countries,
  layout = "grid",
}: CountryFilterChipsProps) {
  const isList = layout === "list";

  const displayedCountries = isList
    ? countries
    : countries.filter((c) => MAIN_COUNTRY_CODES.includes(c.code));

  return (
    <div
      className={
        isList
          ? "flex flex-col gap-1"
          : "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2"
      }
    >
      {displayedCountries.map((country) => (
        <LocationFilterOption
          key={country.code}
          emoji={country.emoji_flag}
          label={country.name}
          selected={selected === country.code}
          onClick={() =>
            onChange(selected === country.code ? null : country.code)
          }
          compact={isList}
        />
      ))}
    </div>
  );
}
